import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { ResponseObject } from '../models/http.models';
import { environment } from 'src/environments/environment';
import { PostTrialActivationResponse } from 'src/app/shared/models/http.models';

@Injectable({ providedIn: 'root' })
export class TrialService {
  private readonly API_URL = `${environment.API_URL}api/v1/trial/`;

  constructor(private readonly http: HttpClient) {}

  /**
   * Makes a post request to activate a trial.
   * @returns It returns an observable of PostTrialActivationResponse.
   */
  activateTrial(): Observable<PostTrialActivationResponse> {
    const url = `${this.API_URL}activate`;
    return this.http.post<PostTrialActivationResponse>(url, {}).pipe(
      map((data: PostTrialActivationResponse) => data)
    );
  }

  /**
   * Makes a post request to capture upgrade intent.
   * @returns It returns an observable of ResponseObject.
   */
  upgradeIntent(): Observable<ResponseObject> {
    const url = `${this.API_URL}upgrade-intent`;
    return this.http.post<ResponseObject>(url, {}).pipe(
      map((data: ResponseObject) => data)
    );
  }
}
